module.exports = __webpack_public_path__ + "img/seaweed.619c6552.png";